import { useEffect } from "react"
import { gdsPlusSetup, wasmModule } from "@/gluelayer"
import { UDTabs } from "../../custom/UDTabs"
import { WeSetupType } from "./WeSetupType"
import { WeSetupArchform } from "./WeSetupArchform"
import { WeSetupAnterior } from "./WeSetupAnterior"
import { WeSetupPosterior } from "./WeSetupPosterior"
import { WeSetupIprSpace } from "./WeSetupIprSpace"
import { RightPage } from "@/UDTreat/right/RightPage"
import { useDispatch } from "react-redux"
import { UDSetupTooth } from "@/UDTreat/UDesign/UDSetupTooth"
import { setDisable } from "@/UDTreat/udSetupSlice"

export const WeSetup = (props) => {
  const dispatch = useDispatch()
  useEffect(() => {
    if (!wasmModule.isInit) return
    gdsPlusSetup.SwitchAutoSetupModule(true)
    return () => {
      console.log("End chairside setup")
      dispatch(setDisable(true))
      gdsPlusSetup.SwitchAutoSetupModule(false)
    }
  }, [])
  return (
    <RightPage
      title="weDesign Setup"
      onClose={props.onClose}
      content={
        <UDTabs
          labels={[
            "Setup Type",
            "IPR/Space",
            "Archform",
            "Anterior",
            "Posterior",
          ]}
        >
          <WeSetupType />
          <WeSetupIprSpace />
          <WeSetupArchform />
          <WeSetupAnterior />
          <WeSetupPosterior />
        </UDTabs>
      }
    />
  )
}
